import { Component } from '@angular/core';
import { BookmarkEntityType, CoreService, ICurrentContext } from '@charlesschwab/sac-ui-core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IAccountCellRendererParams } from './account-cell-renderer.model';
import { RemoveHyphenFromAccountPipe } from '../../pipes/remove-hyphen-from-account.pipe';
import { Observable } from 'rxjs';
import { ContextType } from '@charlesschwab/as-ui-core';
import { AccountInfoActions } from '../../../account-info-header/actions';
import { Store } from '@ngrx/store';
import { IntegrationService } from '../../services/integration.service';
import { MasterTransactionsTableColumn } from '../../types/MasterTransactionsTableColumn';

@Component({
  standalone: false,
  selector: 'msv-account-view-renderer',
  templateUrl: './account-cell-renderer.component.html',
  styleUrls: ['./account-cell-renderer.component.scss']
})
export class AccountCellRendererComponent implements ICellRendererAngularComp {
  params: any;
  currentRowTransaction: MasterTransactionsTableColumn;
  currentContext: ICurrentContext = {
    contextId: 0,
    contextType: ContextType.Account,
    firmId: 0,
    firmName: '',
    title: ''
  };
  public accountUpdated$: Observable<CustomEvent>;
  constructor( 
    private store: Store,
    private coreService: CoreService,
    private integrationService: IntegrationService
  ){}
    
  readonly AccountEntityType = BookmarkEntityType.ACCOUNT;
  accountNumber = '';
  hyphenPipe = new RemoveHyphenFromAccountPipe();

  ngOnInit(): void {
    if (this.coreService?.currentContext) {
      this.currentContext = this.coreService?.currentContext;
    }
  }

  // gets called once before the renderer is used
  agInit(params: IAccountCellRendererParams): void {
    this.accountNumber = params.value.toString();
    this.params = params;
  }

  // gets called whenever the cell refreshes
  refresh(params: IAccountCellRendererParams): boolean {
    this.accountNumber = params.value.toString();
    this.params = params;
    return false;
  }

  accountNumberLink(): void {
    this.currentRowTransaction = this.params.node.data;
    const accountId = this.hyphenPipe.transform(this.currentRowTransaction['Account number']);

    this.integrationService.setContext({
      contextId: Number(accountId),
      contextType: ContextType.Account,
      firmId: this.currentContext?.firmId,
      firmName: this.currentContext?.firmName,
      title: this.currentRowTransaction['Account number'],
      description: this.currentRowTransaction['Account name'],
      accountType: this.currentRowTransaction['Registration type']
    });    
    this.store.dispatch(AccountInfoActions.refresh({ accountId: accountId }));
  }
}
